<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="form">
    <form class="form" id="area_create" @submit.prevent="handleSubmit(onSubmit)">
      <div class="card card-custom">
        <!--begin::Header-->
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">
              Sửa khu vực
            </h3>
          </div>
          <div class="card-toolbar">
            <router-link
                class="font-weight-bold font-size-3  btn btn-secondary"
                :to="{ name: 'area-index' }"
            ><i class="fas fa-angle-double-left"></i> Quay lại
            </router-link>
          </div>
        </div>
        <!--end::Header-->
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Tên khu vực
                  <span class="text-danger">*</span></label>
                <ValidationProvider vid="name" name="Tên khu vực" rules="required" v-slot="{ errors,classes }">
                  <input type="text" ref="name" name="name" class="form-control" v-model="area.name"
                         placeholder="Tên khu vực" :class="classes">
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                        errors[0]
                      }}
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Loại khu vực
                  <span class="text-danger">*</span></label>
                <ValidationProvider vid="name" name="Loại khu vực" rules="required"
                                    v-slot="{ errors,classes }">
                  <el-select v-model="area.type_id"
                             class="w-100"
                             placeholder="Loại khu vực"
                             clearable
                             collapse-tags
                             filterable
                  >
                    <el-option
                        v-for="item in types"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                      <span style="float: left">{{ item.name }}</span>
                    </el-option>
                  </el-select>
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                        errors[0]
                      }}
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

          </div>
          <div>
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-body>
                  <div class="checkbox-inline">
<!--                    <b-form-checkbox class="col-md-3" v-for="(item,index) in area.branches"-->
<!--                                     :key="index"-->
<!--                                     v-model="item.checked"-->
<!--                                     size="lg">{{ item.name_alias ? item.name_alias : item.name }}-->
<!--                    </b-form-checkbox>-->
                      <div class="example-preview table-responsive leaderboard">
                          <table class="table table-vertical-center">
                              <thead class="thead-light">
                                  <tr>
                                      <th>Tên văn phòng</th>
                                      <th>Tên chi nhánh</th>
                                      <th>Thời gian hoạt động</th>
                                      <th>Trạng thái</th>
                                  </tr>
                              </thead>
                              <tbody
                                  v-for="(item, index) in branches"
                                  :key="index"
                              >
                                <td>{{ item.name }}</td>
                                <td>{{ item.name_alias }}</td>
                                <td>{{ item.open_date }}</td>
                                <td>{{ item.status ? 'Hoạt động' : 'Ngừng hoạt động' }}</td>
                              </tbody>
                          </table>
                      </div>
                  </div>
                </b-card-body>
              </b-card>
            </div>
              <div class=" edu-paginate mx-auto d-flex justify-content-center mt-4">
                  <paginate
                      v-model="page"
                      :page-count="last_page"
                      :page-range="3"
                      :margin-pages="1"
                      :click-handler="clickCallback"
                      :prev-text="'Trước'"
                      :next-text="'Sau'"
                      :container-class="'pagination b-pagination'"
                      :pageLinkClass="'page-link'"
                      :next-link-class="'next-link-item'"
                      :prev-link-class="'prev-link-item'"
                      :prev-class="'page-link'"
                      :next-class="'page-link'"
                      :page-class="'page-item'"
                  >
                  </paginate>
              </div>
          </div>
        </div>
        <!--Thông tin cấp trên-->
        <div class="separator separator-dashed my-5"></div>
        <div class="card-header">
          <div class="card-title align-items-start flex-column">
            <button
                type="submit"
                class="btn btn-success mr-2"
            >
              Cập nhật
            </button>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>

</template>
<script>
import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {
  GET_AREA_BY_ID,
  UPDATE_AREA
} from "../../../core/services/store/center/area.module";
import {types} from "@/core/option/area";
import {GET_BRANCHES} from "../../../core/services/store/center/branch.module";

export default {
  components: {
    DatePicker,
  },
  name: "AreaEdit",
  data() {
    return {
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {}
        }
      },
      area: {
        name: '',
        branches: []
      },
      types: types,
      page: 1,
      last_page: 1,
      branches: []
    }
  },
  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý trung tâm", route: 'profile-1'},
      {title: "Sửa khu vực"}
    ]);
    await this.getArea()
    this.getBranchList();
  },
  computed: {},
  methods: {
    onSubmit() {
      this.$store.dispatch(UPDATE_AREA, this.area).then((res) => {
        if (res.error) {
          this.$bvToast.toast(res.message, {
            title: 'Cập nhật',
            variant: 'danger',
            solid: true
          });
        } else {
          this.$router.push({name: "area-index"}).then(() => {
            this.$bvToast.toast(res.message, {
              title: 'Cập nhật',
              variant: 'success',
              solid: true
            });
          })
        }
      }).catch((e) => {
        if (e.data.data.message_validate_form) {
          this.$refs.form.setErrors(e.data.data.message_validate_form);
        }
      });
    },
    getArea() {
      let id = this.$route.params.id;
      this.$store.dispatch(GET_AREA_BY_ID, {
        id: id
      }).then((res) => {
        if (!res.error) {
          this.area = res.data
        }
      }).catch((e) => {
        console.log(e, 'error')
      });
    },
    clickCallback(obj) {
      this.page = obj
      this.$router.push({name: 'area-edit', query: {page: this.page}})
      this.getBranchList()
    },
    getBranchList() {
      this.$store.dispatch(GET_BRANCHES, {
        page: this.page,
        area_id: this.$route.params.id,
        order: true,

      }).then((res) => {
        this.branches = res.data.data
        this.last_page = res.data.last_page
      });
    },
  }
}
</script>
<style scoped>
.mx-datepicker {
  width: 100% !important;
}
</style>
